import styles from "./notfound.module.scss"
export const NotFound = () => {
    return (
        <>
            <div className={styles.root} >
                <div className={styles.glitch} data-text="☹">☹</div>
                <h1 className={styles.glitch} data-text="404">404</h1>
                <p>Not Found Page </p>
            </div>
        </>
    )
}

export default NotFound;